import { type ResponseConfig } from "@kubb/swagger-client/client"
import { notifications } from "@mantine/notifications"
import { UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import {
  findIngestionSettingsQueryKey,
  useUpdateIngestionSettings,
} from "~/gen/api/hooks"
import { IdResponse, UpdateIngestionSettingsRequestDto } from "~/gen/api/types"

export const useUpdateIngestionSettingsMutation = (
  options?: UseMutationOptions<
    ResponseConfig<IdResponse>,
    unknown,
    UpdateIngestionSettingsRequestDto
  >
) => {
  const { t } = useTranslation("organizationSettings")
  return useUpdateIngestionSettings({
    mutation: {
      ...options,
      onSuccess: async (data, variables, context) => {
        options?.onSuccess?.(data, variables, context)
        notifications.show({
          message: t("ingestionSettings.update.success"),
          color: "teal",
        })
        await queryClient.invalidateQueries(findIngestionSettingsQueryKey())
        await queryClient.invalidateQueries(["standards"])
      },
      onError: (error, variables, context) => {
        if (error instanceof AxiosError) {
          notifications.show({
            message: t("ingestionSettings.update.error", {
              error: error.response?.data ?? error.message,
            }),
            color: "red",
          })
        }
        options?.onError?.(error, variables, context)
      },
    },
  })
}
